"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _blindModal = _interopRequireDefault(require("../BlindModal/blindModal"));

var _Card = _interopRequireWildcard(require("../Card"));

var CardBlindModal =
/*#__PURE__*/
function (_BlindModal) {
  (0, _inherits2.default)(CardBlindModal, _BlindModal);

  function CardBlindModal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CardBlindModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CardBlindModal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderChildren", function () {
      var _this$props = _this.props,
          title = _this$props.title,
          children = _this$props.children;
      return _react.default.createElement(_Card.default, null, _react.default.createElement(_Card.CardClose, {
        onClick: _this.close
      }), title && _react.default.createElement(_Card.CardHeader, null, title), _react.default.createElement(_Card.CardContent, null, children));
    });
    return _this;
  }

  return CardBlindModal;
}(_blindModal.default);

exports.default = CardBlindModal;
(0, _defineProperty2.default)(CardBlindModal, "propTypes", {
  title: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
});